import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { clearAdminToken } from '../../utils/adminAuth';

const navItems = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/registrations', label: 'Registrations' },
  { to: '/admin/programs', label: 'Programs' }
];

const AdminNav = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAdminToken();
    navigate('/admin', { replace: true });
  };

  return (
    <div className="mb-8 border border-gray-200 rounded-lg bg-white p-2 flex flex-col sm:flex-row gap-2">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `px-4 py-2 rounded-md text-sm font-semibold transition-colors ${
            isActive ? 'bg-primary text-white' : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          {item.label}
        </NavLink>
      ))}
      <button
        type="button"
        onClick={handleLogout}
        className="px-4 py-2 rounded-md text-sm font-semibold text-red-700 hover:bg-red-50 sm:ml-auto"
      >
        Logout
      </button>
    </div>
  );
};

export default AdminNav;
